import api from '@services/interceptor';
import { useWorkspaceStore } from '@stores/WorkspaceData';
import { toastService } from '@services/plugins/toast';
// Моделирование полётного задания в Pro42. Сервер берёт из базы заявку, план и горизонт,
// результат не хранит — держим его в store для графиков.
// simulationStep — шаг только для этого запуска (STEP_1_20 … STEP_1); null — шаг горизонта,
// горизонт рабочего места при этом не меняется
class SimulationService {
  constructor(){
    this.wp = undefined
  }
  async Run(){
    if(!this.wp)this.wp = useWorkspaceStore()
    try {
      const response = await api.post(`/api/simulation/${this.wp.wpid}`, {simulationStep: this.wp.simulationStep ?? null});
      const warning = response.headers?.['x-warning']
      if(warning) toastService.warn(decodeURIComponent(warning))
      this.wp.simulation = response.data
      return response.data;
    } catch (error) {
      console.log(error)
      const status = error.response?.status
      const message = error.response?.data?.message
      if(status === 400) toastService.error(message || 'Недостаточно данных для моделирования')
      if(status === 502) toastService.error(message || 'Сбой Pro42')
      if(status === 503) toastService.error(message || 'Pro42 не подключён')
    }
    return null
  }
}

export const simulationService = new SimulationService();
